<template>
  <PageWithLayout>
    <div class="section_result">
      <div class="section_body">
        <span class="icon_result_gray"><span class="ico_brand ico_logout"></span></span>
        <h2 class="tit_section">정상적으로 로그아웃 되었습니다.</h2>
        <p class="desc_section">서비스를 이용하시려면 다시 로그인 해주세요.</p>
      </div>
      <div class="section_foot">
        <button class="btn_primary">다시 로그인하기</button>
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import PageWithLayout from '@/components/layout/PageWithLayout';

export default {
  name: 'Logout',
  components: {
    PageWithLayout,
  },
}
</script>